export default __webpack_public_path__ + "static/media/rauchstopp.af70f48b.png";